import { type AxiosResponse } from 'axios'
import api from '../utils/api'

const getPermission = async (): Promise<AxiosResponse> => {
  return await api.get('/api/permissions/entities/')
}

const getPermissionCdg = async (entity: string): Promise<AxiosResponse> => {
  return await api.get('/api/permissions/management/', {
    params: { permission_object: entity },
    headers: {
      Accept: 'application/cdg'
    }
  })
}

export default {
  getPermission,
  getPermissionCdg
}
